import React from 'react';

const Office: React.FC = () => {
  return (
    <section className="py-20 bg-beige-50" id="office">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            <i className="ri-map-pin-line text-amber-600 mr-3"></i>
            事務所案内
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            名古屋市中区栄の便利な立地で、お気軽にお越しいただけます
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* 事務所情報 */}
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-8 rounded-xl border border-amber-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <i className="ri-building-line text-amber-600 mr-3"></i>
                冨田・島岡法律事務所
              </h3>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-map-pin-2-line text-amber-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold text-gray-900">所在地</p>
                    <p className="text-gray-700">
                      〒460-0008<br />
                      愛知県名古屋市中区栄2-12-12<br />
                      アーク栄白川パークビル３階３０５号
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <i className="ri-train-line text-amber-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold text-gray-900">アクセス</p>
                    <p className="text-gray-700">地下鉄東山線・鶴舞線「伏見駅」から徒歩7分</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <i className="ri-wheelchair-line text-amber-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold text-gray-900">バリアフリー</p>
                    <p className="text-gray-700">エレベーター完備のため車いすでもご来所可能</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <i className="ri-parking-line text-amber-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold text-gray-900">駐車場</p>
                    <p className="text-gray-700">近隣にコインパーキング多数あり</p>
                  </div>
                </div>
              </div>
            </div>

            {/* お問い合わせ情報 */}
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-200">
              <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-phone-line text-amber-600 mr-3"></i>
                お問い合わせ
              </h4>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <i className="ri-mail-line text-gray-500"></i>
                  <a href="mailto:shin.kato@tomidashimaoka.com" className="text-amber-600 hover:text-amber-700 font-medium">
                    shin.kato@tomidashimaoka.com
                  </a>
                </div>
                <p className="text-sm text-gray-600 mt-4">
                  <i className="ri-time-line text-gray-500 mr-2"></i>
                  初回相談無料・お気軽にお問い合わせください
                </p>
              </div>
            </div>
          </div>

          {/* Google Map */}
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
              <div className="p-6 bg-gradient-to-r from-amber-500 to-orange-500 text-white">
                <h4 className="text-xl font-bold flex items-center">
                  <i className="ri-map-line mr-3"></i>
                  アクセスマップ
                </h4>
              </div>
              <div className="relative">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.0234567890123!2d136.9123456789!3d35.1654321098!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x600370d1234567890%3A0x1234567890abcdef!2z5ZCN5Y-k5bGL5biC5Lit5Yy65qCE77yS5LiB55uu77yR77yS4oiS77yR77yS!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="冨田・島岡法律事務所の地図"
                ></iframe>
              </div>
            </div>

            {/* 交通案内 */}
            <div className="bg-blue-50 p-6 rounded-xl border border-blue-100">
              <h5 className="font-bold text-gray-900 mb-3 flex items-center">
                <i className="ri-route-line text-blue-600 mr-2"></i>
                詳細アクセス
              </h5>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i>
                  <span>地下鉄東山線・鶴舞線「伏見駅」4番出口から北へ徒歩7分</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-blue-600 mt-0.5"></i>
                  <span>白川公園の向かい側、アーク栄白川パークビル内</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Office;
